import { ENV } from '@backoffice-frontend/environment'

export const REACT_I18NEXT_LANGUAGE_KEY = 'i18nextLng'

export const namespace = `moia.${ENV}`

export const LAST_AUTHENTICATED_USER = `${namespace}.user.last.authenticated.user`
export const LOGIN_INTENDED_PATH = `${namespace}.user.login.intendedPath`
export const MANUALLY_SELECTED_ORGANIZATION = `${namespace}.manually-selected-organization`

export const uiNamespace = `${namespace}.ui`
export const NAV_OPEN_FLAG_KEY = `${uiNamespace}.navOpen`
export const FEATURE_TOGGLES_KEY = `${uiNamespace}.featureToggles`
export const DARK_MODE_KEY = `${uiNamespace}.darkMode`
export const APPEARANCE_KEY = `${uiNamespace}.appearance`

export const EMPLOYEE_SEARCH_FILTER = `${uiNamespace}.employee.employeeSearchFilter`
export const EMPLOYEE_SEARCH_SUPERVISOR_FILTER = `${uiNamespace}.employee.supervisorFilter`
export const EMPLOYEE_AREA_LIST = `${uiNamespace}.employee.list.view`
export const EMPLOYEE_MESSAGE_LIST = `${uiNamespace}.employee.message.filter`
export const EMPLOYEE_STATUSES_FILTER = `${uiNamespace}.employee.statuses.filter`
export const EMPLOYEE_QUALIFICATION_FILTER = `${uiNamespace}.employee.qualification.filter`
export const SHIFT_SEARCH_SUPERVISOR_FILTER = `${uiNamespace}.shift.supervisorFilter`

export const FLEET_HUB_ID_KEY = `${namespace}.fleet.hub`

const serviceAreaManagementNamespace = `${namespace}.serviceAreaManagement`
export const SERVICE_AREA_MANAGEMENT_SERVICE_AREA_ID_KEY = `${serviceAreaManagementNamespace}.serviceAreaId`

export const REGIONS_KEY = `${namespace}.region`

export const MAP_FILTERS_VISIBLE_KEY = `${namespace}.ui.map.filtersVisible`

export const POOLING_MAP_TOGGLE_TRAFFIC_LAYER_KEY = `${namespace}.ui.map.trafficLayerEnabled`

export const CUSTOMER_TENANT_KEY = `${namespace}.customer.tenant`
export const APP_FLAVOR_KEY = `${namespace}.mobile-app-flavor-config.appFlavor`

export const RIDEPOOLING_SERVICE_TENANT_KEY = `${namespace}.ridepooling-service.tenant`

export const SELECTED_FLEETS_KEY = `${namespace}.selectedFleets`

export const ACCOUNTING_LIST_VIEW_CACHE_KEY = `${namespace}.accounting.list.view`
export const ACCOUNTING_GENERAL_LEDGER_VIEW_CACHE_KEY = `${namespace}.accounting.general-ledger.view`

export const SHARE_DOMAIN_SUBDOMAIN_KEY = `${namespace}.share.subdomain`
